export default __webpack_public_path__ + "static/media/insertsortdemo.aa40b43f.gif";